import { SearchNormal } from 'iconsax-react';
import { StyledInput } from './SearchInput.style';
import { useSelector } from 'react-redux';
import { selectLayout } from '@src/store/layout/layoutSlice';

type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
};

export function SearchInput({ value, onChange }: Readonly<SearchInputProps>) {
  const layout = useSelector(selectLayout);
  return (
    <StyledInput
      prefix={<SearchNormal variant='Bulk' />}
      type='text'
      placeholder='Search...'
      value={value}
      onChange={(e) => onChange(e.target.value)}
      variant='filled'
      className='w-full px-3 py-1.5 rounded-md border-none !bg-wl-surface !text-wl-on-background'
      theme={layout.theme}
    />
  );
}
